import { Box } from "@mui/material";
import { ChangeEvent, FormEvent, useState } from "react";
import { SearchForm } from "../common/SearchForm";
import Calendars from "../calendars";
import { ClickBtnParams } from "./contactRecordModal";
import { RadioOption, TableTitle } from "../mobileSize/TableTitle";
import { DotLoader } from "../dotLoader";
import { GetContactRecords } from "../../types/types";
import styled from "@emotion/styled";
import theme from "../../theme";
import { MobileTable } from "../mobileSize/MobileTable";
import { CustomTooltip } from "../common/CustomTooltip";
import Spinner from "../spinner";
import { formatDate, maskContactNumber } from "../../utils/util";

const SORT_LIST: RadioOption[] = [
  { label: `기본 순`, value: `` },
  // { label: `기기명 순`, value: `mobility_name` },
  // { label: `시리얼 번호 순`, value: `device_pid` },
  { label: `이름 순`, value: `owner` },
  { label: `연락처 순`, value: `reading_phone` },
  { label: `구분 순`, value: `who` },
  { label: `연락처 조회 일시 순`, value: `reader_date` },
  { label: `열람자 순`, value: `reader_name` },
];

type Prop = {
  data?: GetContactRecords;
  isLoading?: boolean;
  sort?: string;
  setSort?: React.Dispatch<React.SetStateAction<string | undefined>>;
  onClickBtn: ({ fakeStart, fakeEnd, input }: ClickBtnParams) => void;
};

export const MobileContactRecord = ({
  data,
  isLoading,
  sort,
  setSort,
  onClickBtn,
}: Prop) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [input, setInput] = useState("");

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickBtn({
      fakeStart: startDate,
      fakeEnd: endDate,
      input,
    });
  };
  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      {/* 필터 섹션 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: openFilter ? "auto" : "0px",
          maxHeight: openFilter ? "100vh" : "0px",
          overflow: openFilter ? "visible" : "hidden",
          gap: "6px",
          paddingBottom: openFilter ? "16px" : "0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: `8px`,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Calendars
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            isSeparate={false}
            width={140}
            justifyContent="center"
            gap="8px"
          ></Calendars>
        </Box>

        <SearchForm
          onSubmit={onSubmit}
          placeholder="이름, 연락처 검색"
          onChange={onChange}
          inputValue={input}
          setInputValue={setInput}
          width="100%"
          direction="column"
          gap="6px"
          bottom="0"
          marginR="0"
        />
      </Box>

      {/* 테이블 타이틀 섹션 */}
      <TableTitle
        title={
          isLoading ? (
            <div style={{ height: "15px" }}>
              <DotLoader height="6px" />
            </div>
          ) : (
            `조회된 기록 - ${data?.total_items ?? 0} 건`
          )
        }
        sort={sort}
        setSort={setSort}
        setOpenFilter={setOpenFilter}
        sortList={SORT_LIST}
      />

      {/* 테이블 섹션 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          flexGrow: 1,
        }}
      >
        {isLoading && <Spinner />}
        {data &&
          data.list.length > 0 &&
          data.list.map((el, idx) => (
            <MobileTable
              key={idx.toString()}
              defaultInfoGap="0px"
              defaultInfo={
                <>
                  {/* 첫번째줄 */}
                  <TextWrapper>
                    {/* 기기명 */}
                    {/* <CustomTooltip
                      title={el?.mobility_name}
                      active={!!el?.mobility_name}
                    >
                      <Text $width="41%">
                        {el.mobility_name
                          ? el.mobility_name
                          : "데이터 없음"}
                      </Text>
                    </CustomTooltip> */}
                    {/* 시리얼번호 */}
                    {/* <Text $width="20%" style={{ textAlign: "right" }}>
                      {el.device_pid}
                    </Text> */}
                    {/* 이름 */}
                    <CustomTooltip title={el?.owner} active={!!el?.owner}>
                      <Text $width="49%">
                        {el.owner ? el.owner : "이름 확인 불가"}
                      </Text>
                    </CustomTooltip>
                    {/* 연락처 */}
                    <Text $width="49%" style={{ textAlign: "right" }}>
                      {maskContactNumber(el.reading_phone)}
                    </Text>
                  </TextWrapper>
                  {/* 두번째줄 - 테이블 */}
                  <Table>
                    <thead>
                      <tr>
                        <Th $width="33.33%">열람자</Th>
                        <Th $width="33.33%">연락처 조회 일시</Th>
                        <Th $width="33.33%">구분</Th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <CustomTooltip
                          title={el?.reader_name}
                          active={!!el?.reader_name}
                        >
                          <Td $width="33.33%"> {el?.reader_name}</Td>
                        </CustomTooltip>
                        <CustomTooltip
                          title={formatDate(
                            el.reader_date,
                            "yyyy-MM-dd HH:mm"
                          )}
                          active={!!el?.reader_date}
                        >
                          <Td $width="33.33%">
                            {formatDate(
                              el.reader_date,
                              "yyyy-MM-dd HH:mm"
                            )}
                          </Td>
                        </CustomTooltip>
                        <Td $width="33.33%"> {el.who}</Td>
                      </tr>
                    </tbody>
                  </Table>
                </>
              }
            />
          ))}
        {!isLoading && data && data.list.length === 0 && (
          <NoDataMassage>조회된 데이터가 없습니다.</NoDataMassage>
        )}
      </Box>
    </Box>
  );
};

const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Text = styled.div<{ $fontSize?: string; $width?: string }>`
  font-size: ${({ $fontSize }) =>
    $fontSize ? $fontSize : theme.fontSize.FONT_2};
  flex: ${({ $width }) => ($width ? `0 1 ${$width}` : "1")};
  width: ${({ $width }) => ($width ? $width : "calc(100% - 32px)")};
  max-width: ${({ $width }) =>
    $width ? $width : "calc(100vw- 32px- 32px)"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NoDataMassage = styled.div`
  text-align: center;
  color: ${theme.color.neutral_500};
  padding-top: 200px;
`;

const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  text-align: center;

  tr {
    display: flex;
    width: 100%;
  }
`;

const Th = styled.th<{ $width?: string }>`
  height: 24px;
  line-height: 24px;
  width: ${({ $width }) => $width};
  max-width: ${({ $width }) => $width};
  border: 0.5px solid ${theme.color.neutral_100};
  font-size: ${theme.fontSize.FONT_2};
  font-weight: ${theme.fontWeight.SEMI_BOLD};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Td = styled.td<{ $width?: string }>`
  height: 24px;
  line-height: 24px;
  width: ${({ $width }) => $width};
  max-width: ${({ $width }) => $width};
  border: 0.5px solid ${theme.color.neutral_100};
  font-size: ${theme.fontSize.FONT_2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
